import * as React from 'react';
import { asCurrency, Column, Columns, div, InlineTable, Input, TableCell, TableHeader, TableRow } from 'lqx-react';
import { ErrorHighligter, InputWithMask, DigiDateInput, asTimelessLinkedDate } from '../../shared';
import { Policy } from '../../api/policy';
import { PolicyLabel } from './shared';
import { ReportPeriodTypes } from '../../api/reference-data';
import { DigiSelect } from '../../components/select';

export const PolicyPremiumAndReportingForm = ({ policy, validate }: { policy: Policy, validate }) => {

    return (<>
        <Columns>
            <Column><PolicyLabel>Minimum Premium ($) *</PolicyLabel></Column>
            <Column><PolicyLabel>Deposit Premium ($)</PolicyLabel></Column>
            <Column></Column>
            <Column></Column>
        </Columns>
        <Columns>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'minimumPremium' ] }>
                    <InputWithMask onBlur={ validate } number $value={ policy.policyPremiumSchedule.$.minimumPremium } mask={ asCurrency(policy.policyPremiumSchedule.minimumPremium) } />
                </ErrorHighligter>
            </Column>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'depositPremium' ] }>
                    <InputWithMask onBlur={ validate } number $value={ policy.policyPremiumSchedule.$.depositPremium } mask={ asCurrency(policy.policyPremiumSchedule.depositPremium) } />
                </ErrorHighligter>
            </Column>
            <Column>
            </Column>
            <Column>
            </Column>
        </Columns>
        <Columns>
            <Column><PolicyLabel>Premium Rate</PolicyLabel></Column>
            <Column><PolicyLabel>Premium Basis</PolicyLabel></Column>
            <Column><PolicyLabel>Premium Payment Terms (days) *</PolicyLabel></Column>
            <Column><PolicyLabel>Premium Reporting deadline (days) *</PolicyLabel></Column>
        </Columns>
        <Columns>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'premiumRate' ] }>
                    <Input onBlur={ validate } $value={ policy.$.premiumRate } />
                </ErrorHighligter>
            </Column>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'premiumBasisType' ] }>
                    <Input onBlur={ validate } $value={ policy.premiumBasisType.$.name } />
                </ErrorHighligter>
            </Column>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'premiumPaymentTerms' ] }>
                    <Input onBlur={ validate } number $value={ policy.policyPremiumSchedule.$.premiumPaymentTerms } />
                </ErrorHighligter>
            </Column>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'reportingDeadlineInDays' ] }>
                    <Input onBlur={ validate } number $value={ policy.policyPremiumSchedule.$.reportingDeadlineInDays } />
                </ErrorHighligter>
            </Column>
        </Columns>
        <Columns>
            <Column><PolicyLabel>Amount Past Due Reporting Threshold</PolicyLabel></Column>
            <Column><PolicyLabel>Days Past Due Reporting Threshold *</PolicyLabel></Column>
            <Column><PolicyLabel>Premium Reporting Type</PolicyLabel></Column>
            <Column><PolicyLabel>Enter number of months/periods</PolicyLabel></Column>
        </Columns>
        <Columns>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'amountPastDueRptThreshold' ] }>
                    <InputWithMask onBlur={ validate } number $value={ policy.policyPremiumSchedule.$.amountPastDueRptThreshold } mask={ asCurrency(policy.policyPremiumSchedule.amountPastDueRptThreshold) } />
                </ErrorHighligter>
            </Column>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'daysPastDueRptThreshold' ] }>
                    <Input onBlur={ validate } number $value={ policy.policyPremiumSchedule.$.daysPastDueRptThreshold } />
                </ErrorHighligter>
            </Column>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'reportPeriodType' ] }>
                    <DigiSelect { ...{ onBlur: validate } } id="id" label="name" $value={ policy.policyPremiumSchedule.$.reportPeriodType } options={ ReportPeriodTypes } />
                </ErrorHighligter>
            </Column>
            <Column>
                <ErrorHighligter error={ policy.errors[ 'numberOfPeriods' ] }>
                    <Input onBlur={ validate } number $value={ policy.policyPremiumSchedule.$.numberOfPeriods } />
                </ErrorHighligter>
            </Column>
        </Columns>
        <PremiumAndReportingPeriodLabel>Premium Reporting Period</PremiumAndReportingPeriodLabel>
        <PremiumAndReportingPeriodTableContainer>
            <InlineTable noBorders>
                <TableHeader>
                    <TableCell>FROM</TableCell>
                    <TableCell>TO</TableCell>
                    <TableCell>UTILIZATION</TableCell>
                    <TableCell>PREMIUM ACRUED</TableCell>
                    <TableCell>PREMIUM DUE</TableCell>
                </TableHeader>
                { policy.policyPremiumSchedule.premiumRptPeriodDetails && policy.policyPremiumSchedule.premiumRptPeriodDetails.map(period =>
                    <TableRow key={ period.cid }>
                        <TableCell>
                            <DigiDateInput date $value={ asTimelessLinkedDate(period.$.dateStart) } />
                        </TableCell>
                        <TableCell>
                            <DigiDateInput date $value={ asTimelessLinkedDate(period.$.dateEnd) } />
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                ) }
            </InlineTable>
        </PremiumAndReportingPeriodTableContainer>
    </>
    )
};

const PremiumAndReportingPeriodLabel = div({
    textTransform: 'none',
    color: '#4197d6',
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: 13,
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '20px'
});

const PremiumAndReportingPeriodTableContainer = div({
    paddingTop: '20px',
    paddingLeft: '40px',
    paddingRight: '40px'
});
